'use client';

import React from 'react';
import { InfoWindow } from '@vis.gl/react-google-maps';
import PropTypes from 'prop-types';

MapPopup.propTypes = {
    activeMarker: PropTypes.object,
    activeResult: PropTypes.object,
    onClosePopup: PropTypes.func,
    selectText: PropTypes.string,
    onSelectClicnic: PropTypes.func,
    showDirections: PropTypes.bool,
    showClinicLink: PropTypes.bool,
};

export default function MapPopup({ activeMarker, activeResult, onClosePopup, selectText, onSelectClinic, showDirections, showClinicLink }) {

    return (
        <InfoWindow
            anchor={activeMarker}
            maxWidth={250}
            headerDisabled={true}
        >
            <div className="infoWindow">
                <div className="infoWindow__close" onClick={onClosePopup}>
                    <svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g id="x-circle">
                            <path id="Vector" d="M24 44.5C35.0457 44.5 44 35.5457 44 24.5C44 13.4543 35.0457 4.5 24 4.5C12.9543 4.5 4 13.4543 4 24.5C4 35.5457 12.9543 44.5 24 44.5Z" stroke="#3a2e2e" strokeWidth="2" stroke-Linecap="round" strokeLinejoin="round" />
                            <path id="Vector_2" d="M30 18.5L18 30.5" stroke="#3a2e2e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <path id="Vector_3" d="M18 18.5L30 30.5" stroke="#3a2e2e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </g>
                    </svg>
                </div>

                <h4
                    className="infoWindow__title"
                    dangerouslySetInnerHTML={{
                        __html: activeResult.title,
                    }}
                ></h4>
                {onSelectClinic &&
                    <a
                        href="#"
                        onClick={onSelectClinic}
                        className="infoWindow__book button"
                    >
                        {selectText}
                    </a>
                }
                {showClinicLink &&
                    <a
                        href={`${activeResult.url}`}
                    >
                        Clinic details
                    </a>
                }
                {showDirections &&
                    <a
                        target={'_blank'}
                        href={`https://www.google.com/maps?saddr=My+Location&daddr=${activeResult.lat},${activeResult.lng}`}
                    >
                        Get directions
                    </a>
                }
                <address
                    className="infoWindow__address"
                    dangerouslySetInnerHTML={{
                        __html: activeResult.address.replace(
                            /[<]br[^>]*[>]/gi,
                            ''
                        ),
                    }}
                ></address>
            </div>
        </InfoWindow>
    );
}
